import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-referral-tree-modal',
  templateUrl: './referral-tree-modal.component.html',
  styleUrls: ['./referral-tree-modal.component.scss']
})
export class ReferralTreeModalComponent {
  
  @Input() set setPlayerUUID(val:string) {
    this.playerUUID = val;
    this.getTree();
  }
  public playerUUID:string = "";
  @Output() closeEvent = new EventEmitter();
  
  public data:any = null;
  public loading:boolean = true;

  constructor(private http: HttpService) {}

  async getTree() {
    this.loading = true;
    this.data = await this.http.post("/admin/player/referral/tree", { player_uuid: this.playerUUID });
    this.loading = false;
  }

  selectPlayer(uuid: string) {
    if (!uuid) return;
    this.playerUUID = uuid;
    this.getTree();
  }
}
